<template>
  <sec-section>
    <sec-section-heading :eyebrow="howItRuns.eyebrow" :title="howItRuns.title" />
    <sec-stepper :steps="howItRuns.steps" />
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import SecSectionHeading from '@/components/security/ui/SecSectionHeading.vue';
import SecStepper from '@/components/security/ui/SecStepper.vue';
import { HOME } from '@/content/security/home';

const howItRuns = HOME.howItRuns;
</script>
